import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import AsyncStorage from '@react-native-async-storage/async-storage';
 
 
 
 
const initI18n = async () => {
  const resources = {
    ENG: {
      translation: {
        ...require('./englishTranslation/Homeen.json'),
        ...require('./englishTranslation/W4en.json'),
        ...require('./englishTranslation/I9en.json')
       
      },
    },
    SPA: {
      translation: {
        ...require('./spanishTranslation/Homesp.json'),
        ...require('./spanishTranslation/W4sp.json'),
        ...require('./spanishTranslation/I9sp.json')
       
      },
    },
  };
 
 
  const language = await AsyncStorage.getItem('selectedLanguage') || 'ENG';
  i18next.use(initReactI18next).init({
    compatibilityJSON: 'v3',
    lng: language,
    fallbackLng: "SPA",
    resources,
   
  });
};
 
initI18n();
 
export default i18next;